/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_3_HInputs */

const en_terms_3_h = /** @type {(inputs: Terms_3_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptable use`)
};

const id_terms_3_h = /** @type {(inputs: Terms_3_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penggunaan yang wajar`)
};

/**
* | output |
* | --- |
* | "Acceptable use" |
*
* @param {Terms_3_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_3_h = /** @type {((inputs?: Terms_3_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_3_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_3_h(inputs)
	return en_terms_3_h(inputs)
});